import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import HeaderFive from '../../components/Header/HeaderFive';
import FaqMain from './FaqMain';
import Footer from '../../components/Footer';
import FooterThree from '../../components/Footer/FooterThree';

const Faq = () => {
  return (
    <>
      <HeaderFive />

      <FaqMain />

      <FooterThree />
    </>
  );
};

export default Faq;
